const getCookie = (name) => {
    let cookieArr = document.cookie.split(";")

    for (let i=0; i<cookieArr.length; i++) {
        let cookiePair = cookieArr[i].split("=");
        
        if (name === cookiePair[0].trim()){
            return decodeURIComponent(cookiePair[1]);
        }
    }
    return '';
}

const requestBundleDiscount = async (cartBundleIds, productIds, allProductIds) => {
    const url = 'https://bundle.thimatic-apps.com/cart_bundle.php'
    const params = {
        'shop': 'sennheiser-korea.myshopify.com',
        'cart_bundle_ids': cartBundleIds.join(','),
        'product_ids': productIds.join(','),
        'all_product_ids': allProductIds.join(','),
        'active_currency': 'KRW',
        'active_country': 'KR',
        'cart_type':'cart_page',
        'shopify_theme_id': '887'
    }
    const queryString = new URLSearchParams(params).toString();
    const fullUrl = `${url}?${queryString}`;

    return await fetch(fullUrl, {
        method: 'GET'
    }).then(res => res.json())
}

const fetchNaverPayInfo = async (cart, backUrl, customerId) => {
    const url = 'https://sennheiser-live.lukuku.co/payment/product-info'
    
    const nvadid = getCookie('NVADID')
    const cpavalidator = getCookie('CPAValidator')
    const naco = getCookie('NA_CO')

    const payload = { 
        cart,
        backUrl,
        customerId,
        nvadid,
        cpavalidator,
        naco,
    }
    // console.log({payload})
    return fetch(url, {
        method: 'POST',
        headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })
    .then(response => response.json()) 
    .then(data => {
        if (data.status == 'success') {
            const paymentUrl = data.paymentUrl;
            const orderId = data.orderId;
            const shopId = data.shopId;
            const totalPrice = data.totalPrice;
            const requestUrl = `${paymentUrl}?ORDER_ID=${orderId}&SHOP_ID=${shopId}&TOTAL_PRICE=${totalPrice}` 
            // console.log({orderId});
            // console.log({requestUrl});
            window.location.href= requestUrl;
            // const popupwindow = window.open(requestUrl, 'naverpayPopupWindow', "width=1100,height=auto,scrollbars=yes");
            // if (popupwindow) {
            //     popupwindow.focus();
            // } else {
            //     alert("팝업 창을 차단했습니다. 팝업 차단 설정을 해제해주세요.")
            // }
        }
    })
}

const pdp_buy_nc = () => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const baseUrl = url.origin + url.pathname;
    const queryString = currentUrl.split('?')[1];
    const params = new URLSearchParams(queryString);
    const variantId = params.get('variant');
    const firstVariantId = sessionStorage.getItem('pdp-firstVariantId');
    const customerId = window.customerId

    const quantityInput = document.querySelector('[data-cart-quantity]')
    const quantity = quantityInput.value
    const payload = [{
        productVariantId: variantId || firstVariantId,
        quantity: quantity
    }]
    fetchNaverPayInfo(payload, baseUrl, customerId);
}

const cart_buy_nc = async () => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const baseUrl = url.origin + url.pathname;
    const customerId = window.customerId

    const cartBundleIds = []
    const productIds = []
    const allProductIds = []
    await fetch('cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(response => response.json())
    .then((res) => (
        res.items.map((item) => {
            allProductIds.push(item.product_id)
            if (item.properties?._th_bundle_product) {
                cartBundleIds.push(item.properties?._th_bundle_product)
                productIds.push(item.product_id)
            }
        })
    ))
    .catch((err) => console.log('Error: ', err));

    // console.log({cartBundleIds, productIds, allProductIds})
    // [FIXME] adjust discount
    let discountRes = {}
    if (cartBundleIds.length != 0) {
        discountRes = await requestBundleDiscount(cartBundleIds, productIds, allProductIds)
    }
    // console.log(discountRes)

    let bundleInfo = {}
    discountRes?.bundle_detail?.map(item => {
        const bundle_id = item.bundle_id;
        const discount_type = item.discount_type;
        const discount = item.discount;
        const fixed_discount = item.fixed_discount;
        const products = item.products;
        bundleInfo[bundle_id] = {discount_type, discount, fixed_discount, products, total_price: 0}
    })

    const payload = await fetch('cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(response => response.json())
    .then((res) => {
        res.items.map((item) => {
            if (item.properties?._th_bundle_product) {
                bundleInfo[item.properties?._th_bundle_product]['total_price'] += Number(item.original_price)/100
            }
        })
        let adjustedDiscountedPrice = 0;
        const result = res.items.map((item) => {
            const productId = item.product_id
            const price = Number(item.final_price)/100
            const originalPrice = Number(item.original_price)/100
            let finalPrice = 0
            let discountedQuantity = 0
            if (item.properties?._th_bundle_product) {
                const bundleObj = bundleInfo[item.properties?._th_bundle_product]
                
                const discount_type = bundleObj?.discount_type
                const discount = bundleObj?.discount
                const fixedDiscount = bundleObj?.fixed_discount
                const products = bundleObj?.products
                const totalPrice = bundleObj?.total_price
                
                products.map(item => {
                    if (productId == item.product_id) {
                        discountedQuantity = Number(item.quantity)
                    }
                })
                
                if (discount_type == '1' && fixedDiscount) {
                    if (adjustedDiscountedPrice <= Number(fixedDiscount)) {
                        ratioDiscountedPrice = Math.round(Number(fixedDiscount) * (Number(originalPrice) / Number(totalPrice)));
                        // 반올림으로 인한 차액 제거
                        if ((adjustedDiscountedPrice + ratioDiscountedPrice) >= Number(fixedDiscount) - 10) {
                            const customDiscountPrice = originalPrice - (Number(fixedDiscount) - adjustedDiscountedPrice);
                            // console.log({totalPrice, price, originalPrice, customDiscountPrice})
                            finalPrice = customDiscountPrice;
                        } else {
                            adjustedDiscountedPrice += ratioDiscountedPrice;
                            const customDiscountPrice = originalPrice - ratioDiscountedPrice;
                            // console.log({totalPrice, price, originalPrice, customDiscountPrice})
                            finalPrice = customDiscountPrice;
                        }
                    }
                } else if (discount_type == '0' && discount) {
                    finalPrice = originalPrice * (100 - Number(discount)) / 100;
                } else {
                    finalPrice = price;
                }
            } else {
                finalPrice = price;
            }
            return {
                productVariantId: item.variant_id,
                quantity: item.quantity,
                price: finalPrice,
                discountedQuantity: item.quantity
            }
        })
        return result
    })
    .catch((err) => console.log('Error: ', err));
    fetchNaverPayInfo(payload, baseUrl, customerId);
}

const not_buy_nc = () => {
    alert("구매할 수 없습니다.");
    return;
}
const wishlist_nc = () => {
    console.log("wishlist!")
    return;
}